import Image from 'next/image';
import { Anchor, Box, List, Paragraph } from '@zillow/constellation-10';
import HpLogo from '../../images/iconography/hotpads-logo-with-text.inline.svg';
import LoginStatus from './LoginStatus';
import {
  headerNavDesktopStyles,
  headerNavMobileStyles,
  headerNavStyles,
  logoWrapperStyles,
  mobileLogoStyles,
  navListItemStyles,
  navListStyles,
  navMenuItemStyles,
  navMenuLinkStyles,
  navMobileRightStyles,
} from './styles';
import { css } from '@/styled-system/css';

type Props = {
  email: string;
  loggedIn: boolean;
  firstName: string;
};

const NAV_ITEMS = [
  { label: 'Apartments', href: 'https://hotpads.com/apartments-near-me', isActive: false },
  { label: 'Houses', href: 'https://hotpads.com/houses-near-me', isActive: false },
  { label: 'My Hub', href: 'https://hotpads.com/user/listings/my-hub', isActive: false },
  { label: 'Messages', href: '#', isActive: true },
  { label: 'Alerts', href: 'https://hotpads.com/user/saved-search', isActive: false },
] as const;

export default function HpHeaderNav({ email, loggedIn, firstName }: Props) {
  return (
    <>
      {/* Mobile Header */}
      <Box css={headerNavMobileStyles}>
        <Box css={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
          <Box>
            <a href="/">
              <Image src={HpLogo} width={109} height={24} alt="HotPads Logo" className={css(mobileLogoStyles)} />
            </a>
          </Box>
        </Box>
        <Box css={navMobileRightStyles}>
          <LoginStatus email={email} firstName={firstName} loggedIn={loggedIn} />
        </Box>
      </Box>

      {/* Desktop Header */}
      <Box asChild css={headerNavDesktopStyles}>
        <header>
          <Box asChild css={headerNavStyles}>
            <nav>
              <Box css={logoWrapperStyles}>
                <a href="/">
                  <Image src={HpLogo} width={110} height={29} alt="HotPads Logo" />
                </a>
              </Box>
              <List.Root appearance="none" css={navListStyles}>
                {NAV_ITEMS.map((item) => (
                  <List.Item key={item.label} css={navListItemStyles}>
                    <Paragraph
                      textStyle="body-bold"
                      css={navMenuItemStyles}
                      className={item.isActive ? 'active' : undefined}
                    >
                      <Anchor href={item.href} css={navMenuLinkStyles}>
                        {item.label}
                      </Anchor>
                    </Paragraph>
                  </List.Item>
                ))}
              </List.Root>
            </nav>
          </Box>
          <LoginStatus email={email} firstName={firstName} loggedIn={loggedIn} />
        </header>
      </Box>
    </>
  );
}
